import React from 'react';
import './Styles/Header.css';
import { MdPhoneAndroid, MdMyLocation } from 'react-icons/md';
import { Link } from "react-scroll";
import { GiBasket } from 'react-icons/gi';


const Reload = () => {
  document.location.reload(true);
}

const Header = (props) => {
  const showInMapClicked = () => {
    window.open("https://maps.google.com?q=" + props.lat + "," + props.lng);
  };
  return (

    <><header style={{ display: props.displayHeader, }}>
      <div className="TopHeader">

        <p className="lnbutton" id='location' onClick={showInMapClicked} ><MdMyLocation /> Location </p>
        <a href={props.number} id='call' className="lnbutton" > <MdPhoneAndroid />Call Us </a>

        {/* Cart pic */}
        {(props.screenSize > 1503 )&& (
        <Link  id="0900" activeClass="active" smooth spy to="AddCart-div" activeStyle={{ backgroundColor: "black", }} offset={0} >
      
        <GiBasket className='basket'/>
     
        </Link>)}


      </div>

      {/* LOGO */}
      <img src={props.logo} className='logo' alt='' onClick={Reload} />
    </header>
    </>
  )
}
Header.defaultProps = {
  cart: "https://img.icons8.com/external-creatype-outline-colourcreatype/64/null/external-app-web-application-2-creatype-outline-colourcreatype-11.png",
  logo: "https://admin.indolj.io/upload/1634887125-1634539656-1631641123-logo-min.webp",
  number: "tel:2348101234567",
  lat: "24.84538526818595",
  lng: "66.99110440376445"
}
export default Header;



